import script from "./TransactionDetailPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./TransactionDetailPage.vue?vue&type=script&setup=true&lang=ts"

import "./TransactionDetailPage.vue?vue&type=style&index=0&id=47487bec&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47487bec"]])

export default __exports__